import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectRegionsQueryItems } from '../../../../../redux/route-management/regions/selector';
import VariantComponent from '../components/variant.component';
import { variants } from '../../../../../redux/variants/action';
import { products } from '../../../../../redux/products/action';
import { selectProductsListItems } from '../../../../../redux/products/selector';
import { selectVariantsQueryItems } from '../../../../../redux/variants/selector';

const ManagementVariant = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const ProductLists = useSelector(selectProductsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const variantsQuery = useSelector(selectVariantsQueryItems)
  const [
    selectedVariants,
    setSelectedVariants
  ] = useState<any>([])

  const fetchVariantsQueryById = () => {
    dispatch(variants.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/query`, entity: 'variants', jsonData: {

        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedVariants({ ...selectedVariants, [field]: event })
  }

  useEffect(
    () => {
      dispatch(products.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/products/list`, entity: 'products', jsonData: {}

      })).then(() => {
        if (parmas?.id > 0) {
          fetchVariantsQueryById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedVariants(variantsQuery?.result?.items)

      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      await dispatch(variants.resetAction({ actionType: 'update' }))
      await dispatch(variants.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants`, entity: 'variants', jsonData: {

          Records: [
            selectedVariants

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(variants.resetAction({ actionType: 'create' }))
      await dispatch(variants.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants`, entity: 'variants', jsonData: {

          Records: [
            selectedVariants
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/logistics/variants')
  }
  return (
    <>
      {isLoading ? <PageLoader /> :


        <VariantComponent
          selectedVariants={selectedVariants}
          products={ProductLists?.result?.items}
          onInnerBasicFormChange={handleInnerbasicFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }

    </>
  )

}

export default ManagementVariant;